import axios from "axios";

function crearLiquidacion(data) {
    return axios.post('api/liquidacion/crearLiquidacion', data).then(r => r.data).catch(r => r);
}

function eliminarLiquidacion(data) {
    return axios.post('api/liquidacion/eliminarLiquidacion', data).then(r => r.data).catch(r => r);
}

function traerDetalleliquidacion(data) {
    return axios.post('api/liquidacion/traerDetalleliquidacion', data).then(r => r.data).catch(r => r);
}

function traerDetalleliquidacionAsociado(data) {
    return axios.post('api/liquidacion/traerDetalleliquidacionAsociado', data).then(r => r.data).catch(r => r);
}

function traerFacturasPendientes(data) {
    return axios.post('api/liquidacion/traerFacturasPendientes', data).then(r => r.data).catch(r => r);
}

function traerFacturasPagadas(data) {
    return axios.post('api/liquidacion/traerFacturasPagadas', data).then(r => r.data).catch(r => r);
}

function pagarFacturas(data) {
    return axios.post('api/liquidacion/pagarFacturas', data).then(r => r.data).catch(r => r);
}

function devolverFactura(data) {
    return axios.post('api/liquidacion/devolverFactura', data).then(r => r.data).catch(r => r);
}

export {
    crearLiquidacion,
    eliminarLiquidacion,
    traerDetalleliquidacion,
    traerDetalleliquidacionAsociado,
    traerFacturasPendientes,
    traerFacturasPagadas,
    pagarFacturas,
    devolverFactura
}
